const collectionName = 'paymentGateways';

export { collectionName };
